<template>
    <div class="row mx-0">
        <div class="col-md-12 main-content">
            <div class="d-flex justify-content-between">
                <h1 class="first-header heading-large"><i class="fas fa-chart-line mr-2"></i>All Prices</h1>
                <refresh-information />
            </div>
            <div class="panel-tabs">
                <div class="nav-tabs_parent">
                    <ul class="nav nav-tabs">
                        <li class="nav-item" :class="{active: activeTabIndex == key}" 
                            v-for="(offerType, key) in offerTypes" :key="key">
                            <a class="nav-link" @click="selectLocalTab(key)"
                                href="#">{{offerType}}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="panel-tab-content">
                    <offers-table class="card border-radius-top-left-0"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OffersTable from '@/components/OrderTables/OffersTable.vue'
import RefreshInformation from '@/components/RefreshInformation.vue';
import PageRefreshMixin from '@/mixins/PageRefreshMixin';

export default {
    mixins: [PageRefreshMixin],
    components: {
        OffersTable,
        RefreshInformation
    },
    data(){
        return {
            offerTypes: ['Ex-Rack', 'Bunkering', 'Contracts' ,'Delivered In'],
            linksToProduct: ['/AllPrices/ex-rack', '/AllPrices/bunkering' ,  '/AllPrices/contract', '/AllPrices/deliveredIn'],
        }
    },
    created() {
        if (this.$router.history.current.params.tab==="ex-rack"){
            this.selectTab(0)
        }if (this.$router.history.current.params.tab==="bunkering"){
            this.selectTab(1)
        }else if (this.$router.history.current.params.tab==="contract"){
            this.selectTab(2)
        }else if (this.$router.history.current.params.tab==="deliveredIn"){
            this.selectTab(3)
        }

        this.getLiveOffers();
        this.getDeliveryLocations();
        this.startPageRefresh(() => {
            this.getLiveOffers();
            this.getDeliveryLocations();
        });
    },
    computed: {
        ...mapGetters('allPrices', ['activeTabIndex']),
    },
    methods: {
        ...mapActions('allPrices', ['selectTab']),
        ...mapActions('offers', ['getLiveOffers', 'getDeliveryLocations']),
        selectLocalTab: function(index){
            event.preventDefault()
            this.$router.push(this.linksToProduct[index])
            this.selectTab(index)
        }
    }
}
</script>
